import { ColDef, ColGroupDef } from 'ag-grid-community'
import { fotmatDateHeader } from '../../../../../global.d'
import { callSP, getFlaskRunPlantilla } from '../../../../../setup/axios/AxiosCallSP'
import { error, success, warn } from '../../../../utils/customToasd'
import { armarRow } from '../../minutaFood/services/serviceMinutaFood/serviceMinutaFood'
import { headerMinutaVertical } from '../IMinutaVertical'
import * as Yup from 'yup'
import axios from 'axios'

export const informationPlanings = (rowLunchGrid: any, dataRowModal: any, setDataRowModal: any) => {
  let contIngrediente: any = []
  let idIng: any = []
  rowLunchGrid.map((item: any) => {
    item.map((item2: any, key: number) => {
      for (let i = 1; i <= item.length; i++) {
        if (item2['idIngredientePrincipal' + i] !== undefined) {
          if (contIngrediente[item2['idIngredientePrincipal' + i]] === undefined) {
            contIngrediente[item2['idIngredientePrincipal' + i]] = 0
            const dataF = dataRowModal.filter(
              (item3: any) => item3.id_ingrediente_principal === item2['idIngredientePrincipal' + i]
            )
            if (dataF.length === 0) {
              idIng.push({
                Nombretipoingprincipal: item2['Nombretipoingprincipal' + i],
                id_ingrediente_principal: item2['idIngredientePrincipal' + i],
                total: 0,
                totalModificado: 0,
              })
            }
          }
          contIngrediente[item2['idIngredientePrincipal' + i]]++
        }
      }
    })
  })
  if (idIng.length > 0) {
    idIng.map((item: any) => {
      dataRowModal.push(item)
    })
  }
  const newDataRowModal = dataRowModal.map((item: any) => {
    const totalIngredienteModificado = contIngrediente.find(
      (item2: any, key: number) => key === item.id_ingrediente_principal
    )
    item.totalModificado = totalIngredienteModificado
    return item
  })
  setDataRowModal(newDataRowModal)
}

export const columnModalValidate = () => {
  const dataColum: (ColDef | ColGroupDef)[] = [
    {
      field: 'periodo',
      headerName: 'Periodo',
      minWidth: 300,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'texto',
      headerName: 'Texto',
      minWidth: 300,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'estado',
      headerName: 'Estado',
      minWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
  ]
  return dataColum
}

export const columnDetailModal = () => {
  const dataColum: (ColDef | ColGroupDef)[] = [
    {
      field: 'Nombretipoingprincipal',
      headerName: 'Ingrediente Principal',
      minWidth: 300,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'total',
      headerName: 'Total',
      minWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'totalModificado',
      headerName: 'Total Modificado',
      minWidth: 180,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
  ]
  return dataColum
}

export const getOrderHeader = (dataHeader: headerMinutaVertical[]) => {
  dataHeader.filter((item) => item.ciclo_iterar)
  const result = dataHeader.reduce((acc: number[], item) => {
    if (!acc.includes(item.ciclo_iterar)) {
      acc.push(item.ciclo_iterar)
    }
    return acc
  }, [])
  let data: any[] = []
  result.map((itemd, key) => {
    const datResult = dataHeader.filter((item) => item.ciclo_iterar === key + 1)
    if (datResult) data[key] = datResult
  })
  const fechaPorCiclo: any[] = []
  let cont = 0
  let cont2 = 0
  data.forEach((item, key) => {
    cont = 0
    cont2 = 0
    item.forEach((item: any, key2: number) => {
      cont++
      if (fechaPorCiclo[key] === undefined) {
        fechaPorCiclo[key] = []
      }
      if (cont > 7) {
        cont2++
        cont = 0
      }
      if (fechaPorCiclo[key][cont2] === undefined) {
        fechaPorCiclo[key][cont2] = []
      }
      item.fecha = fotmatDateHeader(item.fecha)

      if (key2 === 0) {
        fechaPorCiclo[key][cont2].push({
          text: 'Estructura servicios',
        })
      }
      fechaPorCiclo[key][cont2].push(item)
    })
  })
  return fechaPorCiclo
}

export const getOrderRow = (
  planillaContrato: IPlanillaContrato[],
  estructuraContrato: IEstructuraContrato[]
) => {
  let arrayEstructura: any = []
  planillaContrato.forEach((item) => {
    item.fecha = fotmatDateHeader(item.fecha)
    if (arrayEstructura[item.idEstructura] === undefined) {
      arrayEstructura[item.idEstructura] = []
    }
    const result: any = estructuraContrato.filter(item2 => item2.id === item.idEstructura)
    item.order = result[0].orden
    arrayEstructura[item.idEstructura].push(item)
  })
  return arrayEstructura
}

export const armarDataRow = (fechas: string[], dataRow: any) => {
  const filterDataRow: any = [];
  let contador = 0;
  dataRow.forEach((item: any, key: number) => {
    contador++
    item.forEach((item2: any, key2: any) => {
      if (fechas.includes(item2.fecha)) {
        filterDataRow.push(item2)
      }
    })
  })
  return filterDataRow
}

export const createMinutaRow = (item2: any, dataRow: any, structureSelected: any) => {
  item2.forEach((it: any, k: number) => {
    if (k === 0) {
      it.showModal = true
      it.id = k
      it.key = 'nombreEstructura'
      it.width = '100'
      it.value = k
      it.classNameRow = 'clase-row-1'
    } else {
      it.id = k
      it.key = 'Nombretipoingprincipal' + k
      it.show = false
      it.showModalItem = true
      it.text = it.fecha
      it.value = k
      it.classNameColum = 'th-table th-table th-table clase-2 colum-fecha colum-fecha colum-fecha'
      it.classNameRow = 'clase-row-2'
    }
  })
  const fechas = item2.map((item: any) => {
    if (item.fecha) return item.fecha
  })
  const itemRow = armarDataRow(fechas.slice(1, fechas.length), dataRow)
  const data: any[] = []
  const dataColor: any[] = []
  const idStruct: any[] = []
  itemRow.forEach((item: any) => {
    if (!idStruct.includes(item.nombreEstructura)) {
      if (structureSelected.length === 0) {
        idStruct.push(item.nombreEstructura)
        data.push({
          id: item.idEstructura,
          nombre: item.nombreEstructura,
        })
      } else {
        structureSelected.map((item2: number) => {
          if (item2 === item.nombreEstructura) {
            idStruct.push(item.nombreEstructura)
            data.push({
              id: item.idEstructura,
              nombre: item.nombreEstructura,
            })
          }
        })
      }
    }
  })
  const json = {
    columRow: data,
    dataRow: itemRow,
    header: fechas.slice(1, fechas.length),
  }
  return armarRow(json)
}

const enableSwitch = (
  sitios: any,
  getServices: any,
  servicios: any,
  regimens: any,
  setLoad: any,
  setAlertModal: any,
  values: any,
  input: any,
  setFieldValue: any,
  est: any[] = []
) => {
  setFieldValue(input, values[input])
  let json = {
    cabecera: true,
    estructura: false,
    estructuraFija: false,
    recetaFija: false,
    frecuenciaIngredientes: false,
    reglas: false,
    plantilla: false,
    seleccionarEstructura: false,
  }
  if (values.cabecera) {
    json.estructura = true
    json.estructuraFija = true
    json.reglas = true
  }
  if (values.estructuraFija) {
    json.recetaFija = true
    json.frecuenciaIngredientes = true
  }
  if (
    values.cabecera &&
    values.estructura &&
    values.estructuraFija &&
    values.recetaFija &&
    values.frecuenciaIngredientes &&
    values.reglas
  ) {
    json.plantilla = true
  }
  if (values.seleccionarEstructura) json.seleccionarEstructura = true

  setAlertModal(
    inputMinutaModal(sitios, getServices, servicios, regimens, setLoad, setAlertModal, json, est)
  )
}
export const inputMinutaModal = (
  sitios: any,
  getServices: any,
  servicios: any,
  regimens: any,
  setLoad: any,
  setAlertModal: any,
  inputSwich: any,
  estructuras: any = []
): any => {
  const arrInput: any = [
    {
      columInput: 3,
      campo: 'place',
      label: 'Sitio',
      type: 'autocomplete',
      campoChk: true,
      advanceOptions: {
        id: 'palce-input',
        placeholder: 'Ingrese sitio',
        multiple: false,
        options: sitios,
      },
      className: 'form-control b-0 p-0 form-control-lg input-contract',
      onChange: async function (event: any, setFieldValue: any, values: any) {
        if (values.place.length > 0) {
          setLoad(true)
          getServices(values.place[0].value, setFieldValue, values, this, estructuras)
        }
      },
    },
    {
      columInput: 3,
      campo: 'service',
      label: 'Servicio',
      type: 'autocomplete',
      advanceOptions: {
        id: 'service-input',
        multiple: false,
        placeholder: 'Ingrese servicio',
        options: servicios,
      },
      onChange: async (event: any, setFieldValue: any, values: any) => {
        setTimeout(() => {
          setFieldValue('service', values.service)
        }, 500)
      },
      className: 'form-control b-0 p-0 form-control-lg input-contract',
    },
    {
      columInput: 3,
      campo: 'regime',
      label: 'Regimen',
      type: 'autocomplete',
      advanceOptions: {
        id: 'regime-input',
        placeholder: 'Ingrese régimen',
        multiple: false,
        options: regimens,
      },
      onChange: async (event: any, setFieldValue: any, values: any) => {
        setTimeout(() => {
          setFieldValue('regime', values.regime)
        }, 500)
      },
      className: 'form-control b-0 p-0 form-control-lg input-contract',
    },
    {
      columInput: 4,
      campo: 'cabecera',
      type: 'checkbox',
      disabled: !inputSwich.cabecera,
      className: 'form-check-input day-select',
      label: 'Cabecera',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('cabecera', !values.cabecera)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'cabecera',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 4,
      campo: 'estructura',
      type: 'checkbox',
      disabled: !inputSwich.estructura,
      className: 'form-check-input day-select',
      label: 'Estructura',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('estructura', !values.estructura)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'estructura',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 4,
      campo: 'estructuraFija',
      type: 'checkbox',
      disabled: !inputSwich.estructuraFija,
      className: 'form-check-input day-select',
      label: 'Estructura Fija',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('estructuraFija', !values.estructuraFija)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'estructuraFija',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 4,
      campo: 'recetaFija',
      type: 'checkbox',
      disabled: !inputSwich.recetaFija,
      className: 'form-check-input day-select',
      label: 'Receta Fija',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('recetaFija', !values.recetaFija)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'recetaFija',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 4,
      campo: 'frecuenciaIngredientes',
      type: 'checkbox',
      disabled: !inputSwich.frecuenciaIngredientes,
      className: 'form-check-input day-select',
      label: 'Frecuencia Ingredientes',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('frecuenciaIngredientes', !values.frecuenciaIngredientes)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'frecuenciaIngredientes',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 4,
      campo: 'reglas',
      type: 'checkbox',
      disabled: !inputSwich.reglas,
      className: 'form-check-input day-select',
      label: 'Reglas',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('reglas', !values.reglas)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'reglas',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 4,
      campo: 'plantilla',
      disabled: !inputSwich.plantilla,
      type: 'checkbox',
      className: 'form-check-input day-select',
      label: 'Plantilla',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('plantilla', !values.plantilla)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'plantilla',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 4,
      campo: 'seleccionarEstructura',
      type: 'checkbox',
      className: 'form-check-input day-select',
      label: 'Seleccionar Estructura',
      isSwitch: true,
      onInput: async (event: any, setFieldValue: any, values: any) => {
        setFieldValue('seleccionarEstructura', !values.seleccionarEstructura)
        enableSwitch(
          sitios,
          getServices,
          servicios,
          regimens,
          setLoad,
          setAlertModal,
          values,
          'seleccionarEstructura',
          setFieldValue,
          estructuras
        )
      },
    },
    {
      columInput: 3,
      campo: 'structure',
      label: 'Estructura',
      type: 'autocomplete',
      advanceOptions: {
        id: 'structure-input',
        placeholder: 'Ingrese estructura',
        multiple: true,
        options: estructuras,
      },
      onChange: async (event: any, setFieldValue: any, values: any) => {
        setTimeout(() => {
          setFieldValue('structure', values.structure)
        }, 500)
      },
      className: 'form-control b-0 p-0 form-control-lg input-contract',
    },
  ]

  if (!inputSwich.seleccionarEstructura) {
    arrInput.splice(11, 1)
  }
  return {
    title: 'Replicar Contrato',
    message: '',
    arrayInput: arrInput,
    save: async (value: any, setFieldValue: any, _formikProps: any, params: any) => {
      setLoad(true)
      if (!inputSwich.seleccionarEstructura)
        replicacionContrato(value, _formikProps, setAlertModal, params, setLoad)
      else replicacionContratoEst(value, _formikProps, setAlertModal, params, setLoad)
    },
  }
}

export const replicacionContrato = async (
  value: any,
  _formikProps: any,
  setAlertModal: any,
  params: any,
  setLoad: any
) => {
  try {
    const result: any = await callSP('amd_replicarContrato', [
      { text: 'contrato', value: params.id.toString() },
      { text: 'sitio', value: value.place[0].value.toString() },
      { text: 'regimen', value: value.regime[0].value.toString() },
      { text: 'servicio', value: value.service[0].value.toString() },
      { text: 'recetaFija', value: (value.recetaFija ? 1 : 0).toString() },
      { text: 'estructura', value: (value.estructura ? 1 : 0).toString() },
      { text: 'frecuencia', value: (value.frecuenciaIngredientes ? 1 : 0).toString() },
      { text: 'estructuraFija', value: (value.estructuraFija ? 1 : 0).toString() },
      { text: 'reglas', value: (value.reglas ? 1 : 0).toString() },
      { text: 'plantilla', value: (value.plantilla ? 1 : 0).toString() },
    ])
    if (result.status == '200') {
      success('Creado exitosamente!!!')
    } else {
      error('Problema al replicar el contrato')
    }
    setAlertModal(undefined)
    setLoad(false)
  } catch (err) {
    console.log(err)
    error('Problema al replicar el contrato')
    setLoad(false)
    setAlertModal(undefined)
  }
}

export const replicacionContratoEst = async (
  value: any,
  _formikProps: any,
  setAlertModal: any,
  params: any,
  setLoad: any
) => {
  try {
    const result: any = await callSP('amd_replicarContratoEstructura', [
      { text: 'contrato', value: params.id.toString() },
      { text: 'sitio', value: value.place[0].value.toString() },
      { text: 'regimen', value: value.regime[0].value.toString() },
      { text: 'servicio', value: value.service[0].value.toString() },
      { text: 'recetaFija', value: (value.recetaFija ? 1 : 0).toString() },
      { text: 'estructura', value: (value.estructura ? 1 : 0).toString() },
      { text: 'frecuencia', value: (value.frecuenciaIngredientes ? 1 : 0).toString() },
      { text: 'estructuraFija', value: (value.estructuraFija ? 1 : 0).toString() },
      { text: 'reglas', value: (value.reglas ? 1 : 0).toString() },
      { text: 'plantilla', value: (value.plantilla ? 1 : 0).toString() },
      { text: 'id_estructura ', value: value.structure.map((e: any) => e.value).join(',') },
    ])
    if (result.status == '200') {
      success('Creado exitosamente!!!')
    } else {
      error('Problema al replicar el contrato')
    }
    setAlertModal(undefined)
    setLoad(false)
  } catch (err) {
    console.log(err)
    error('Problema al replicar el contrato')
    setLoad(false)
    setAlertModal(undefined)
  }
}

export const runPlantilla = async (params: any, setInfoModal: any, setLoad: any) => {
  try {
    await getFlaskRunPlantilla({ idContrato: params.id.toString() })
    success('Plantilla creada exitosamente')
    setInfoModal(false)
    setLoad(false)
  } catch (err) {
    error('Error al crear la plantilla', 'bottom-center')
    setInfoModal(false)
    setLoad(false)
    Promise.reject(err)
  }
}

export const validateSchemaModal = (title?: string) => {
  if (title !== 'Reprocesar Minuta') {
    return Yup.object().shape({
      place: Yup.array().validateArray(),
      regime: Yup.array().validateArray(),
      service: Yup.array().validateArray(),
    })
  } else {
    return Yup.object().shape({
      estructura2: Yup.array().validateArray(),
      macroEstructura: Yup.array().validateArray(),
    })
  }
}
export interface IPlanillaContrato {
  IsFeriado: number
  RecFija: number
  WK: number
  ciclo: number
  contrato: number
  dia: number
  dia_ciclo: number
  estado: number
  estructura_padre: number
  fecha: string
  icon: string
  idEstructura: number
  idIngredientePrincipal: number
  id_grupo_estructura: number
  nombreEstructura: string
  order?: number
}
export interface IEstructuraContrato {
  head: number
  id: number
  id_alergeno: number
  id_categoria_dietetica: number
  id_contrato: number
  id_estilo_aliminatacion: number
  id_grupo_estructura: number
  id_intolerancia: number
  id_sellos: number
  nombre: string
}
